import React from 'react';
import { Phone } from 'lucide-react';

const LetsConnect = ({
   badge = "Schedule Consultation",
   heading = "Let's Connect",
   subtitle = "Connect with our experts for a free consultation and tailored solutions.",
   submitLabel = "Schedule a Free Consultation",
}) => {
   return (
      <section className="lets-connect">
         <div className="tw-container tw-mx-auto">
            <div className="lets-connect__inner">
               <div className="lets-connect__form-col">
                  <span className="lets-connect__badge">{badge}</span>
                  <h2 className="lets-connect__heading">{heading}</h2>
                  <p className="lets-connect__subtitle">{subtitle}</p>

                  <form className="lets-connect__form contact__form" onSubmit={(e) => e.preventDefault()}>
                     <div className="lets-connect__form-row">
                        <div className="lets-connect__field">
                           <label htmlFor="lc-name">Your name</label>
                           <input id="lc-name" type="text" required placeholder="e.g. John Smith" />
                        </div>
                        <div className="lets-connect__field">
                           <label htmlFor="lc-email">Email address</label>
                           <input id="lc-email" type="email" required placeholder="e.g. john@email.com" />
                        </div>
                     </div>
                     <div className="lets-connect__form-row">
                        <div className="lets-connect__field">
                           <label htmlFor="lc-phone">Phone number</label>
                           <input id="lc-phone" type="tel" placeholder="e.g. +91 90303 50309" />
                        </div>
                        <div className="lets-connect__field">
                           <label htmlFor="lc-company">Company name</label>
                           <input id="lc-company" type="text" placeholder="e.g. Harsoft Solutions" />
                        </div>
                     </div>
                     <div className="lets-connect__field">
                        <label htmlFor="lc-message">Your message</label>
                        <textarea id="lc-message" required placeholder="Type here ..."></textarea>
                     </div>
                     <button type="submit" className="lets-connect__submit">{submitLabel}</button>
                  </form>
               </div>

               <div className="lets-connect__media-col">
                  <div className="lets-connect__media">
                     <img src="assets/img/contact/Harsofts_letsconnect_img.png" alt="Harsoft Solutions team collaborating" />
                  </div>
                  <div className="lets-connect__callout">
                     <span className="lets-connect__callout-icon"><Phone size={18} /></span>
                     <p>Call us at <a href="tel:+919030350309">(+91) 90303 50309</a> or fill out our form, and we'll contact you within one business day.</p>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
};

export default LetsConnect;
